import { useIdentityStatus } from "@/lib/api/hooks";

/** Read-only pilot copy; does not alter purchases, renewals, or appointments. */
export function PrescriptionBillingNotice() {
  const identity = useIdentityStatus();
  if (!identity.data?.enabled) return null;
  return (
    <section
      className="border border-line-subtle bg-sunken p-15"
      aria-label="Billing and prescription authorization"
    >
      <h2 className="type-label-sm">Billing and prescription authorization</h2>
      <p className="type-body-sm text-ink-secondary mt-8">
        Your billing schedule is separate from your clinician’s prescription
        authorization. Paying for or renewing a plan does not automatically
        authorize medication or additional refills.
      </p>
      <p className="type-body-sm text-ink-secondary mt-8">
        A new prescription and clinical check-in are needed once your authorized
        supply ends. Your clinician determines the medication, dose, and number
        of refills appropriate for you.
      </p>
    </section>
  );
}
